import * as React from 'react';

import { NumberField } from '@cian/components';

interface IContactProps {
  value: number | undefined;
  onChange(value?: number | undefined): void;
}

export const OfferId: React.StatelessComponent<IContactProps> = props => (
  <NumberField disableFractional disableNegative value={props.value} onValueChange={props.onChange} />
);
